import Markdown from 'react-markdown';
import { Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


function LinkRenderer(props) {
    return (
        <a href={props.href} target="_blank" rel="noreferrer" style={styles.link}>
        {props.children}
        </a>
    );
}

const MarkdownRenderer = ({ children }) => {
    return (
        <Markdown components={{ a: LinkRenderer }}>{children}</Markdown>
    );
};

const Info = ({setOpen}) => {
    return <div style={styles.infoCard}  onClick={(e) => e.stopPropagation()}>
            <IconButton style={styles.closeButton} onClick={() => setOpen(false)}>
                    <CloseIcon />
            </IconButton>
            <div style={{...styles.textContainer, fontFamily: 'Montserrat, sans-serif'}}>
            <Typography variant="body2" gutterBottom style={styles.text}>
                <MarkdownRenderer linkTarget="_blank">
                    Welcome to the **Card Plane!**
                </MarkdownRenderer>
                <MarkdownRenderer>
                    Created by [Martí Rubio](https://www.martirubio.cat).
                </MarkdownRenderer>
            </Typography>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                What is this?
                </AccordionSummary>
                <AccordionDetails>
                This is a webpage that shows all the 92976 unique printings that MTG currently has.
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                How does this webpage work?
                </AccordionSummary>
                <AccordionDetails>
                When searching for MTG cards you need to know what you were searching for.
                This webpage aims to do something different. It tries to show "similar" cards next to each other, so if you need to replace a card, 
                some good alternatives should be around.
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                How are the cards ordered?
                </AccordionSummary>
                <AccordionDetails>
                    <MarkdownRenderer linkTarget="_blank">
                    Using AI, like everything nowadays. I parsed all MTG cards and extracted the fields that felt important: oracle text, mana cost, color... 
                    With that I created an [embedding](https://en.wikipedia.org/wiki/Word_embedding) for each card and mapped that result onto a 2D space, the map of points that you see!
                    </MarkdownRenderer>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                I saw cards that are not similar next to each other...
                </AccordionSummary>
                <AccordionDetails>
                Most probably! Card similarity comes from perception and game knowledge, so I'm sure that 2 players would not agree on 
                how to universaly define what similar cards are. That being said, relying on AI has those drawbacks. The embedding process does not know/care 
                about the rules of MTG, so the result comes with a bias towards similar text instead of similar gameplay.
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                Why did you do it?
                </AccordionSummary>
                <AccordionDetails>
                I wanted to start playing MTG and got overwhelmed about the amount of cards available. So before starting I wanted to explore the whole universe
                that this game offers. So yes, all of that is done and I don't have a single MTG card. I guess I'll use donations to start a deck!
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                >
                Is it really useful?
                </AccordionSummary>
                <AccordionDetails>
                I hope so! I wanted this map to be able to give players some new ideas about cards that they might have forgotten about. I also realised that there wasn't
                a webpage where I could see all the cards at once, and I thought that it would be cool. So maybe this is more an artistic project than a useful one.
                </AccordionDetails>
            </Accordion>
        </div>
    </div>
}

const styles = {
    infoCard: {
        position: 'absolute',
        zIndex: '210',
        backgroundColor: '#fbfaf2',
        padding: '20px',
        borderRadius: '20px',
        // borderColor: '#AFD8EF',
        // borderWidth: '5px',
        // borderStyle: 'solid',
        maxHeight: '85vh',
        maxWidth: '85vw',
        margin: '0 auto',
        textAlign: 'center',
        display: 'inline-block',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: "url('../../public/data.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'scroll',
    },
    question: {
        color: 'black',
        marginRight: '2em',
        marginLeft: '1em',
        fontSize: '24px',
        fontFamily: 'Montserrat, sans-serif',
    },
    text: {
        color: 'black',
        marginRight: '2em',
        marginLeft: '2em',
        fontSize: '18px',
        marginTop: '0px',
        fontFamily: 'Montserrat, sans-serif',
    },
    closeButton: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: 'black',
        backgroundColor: '#ccccccbb',
    }
}

export default Info;